<template>
    <div class="tw-container tw-m-auto tw-mt-32 md:tw-w-2/3 tw-p-4 tw-w-full">
      <div class="md:tw-text-right tw-font-sans tw-text-center md:tw-text-3xl tw-text-3xl tw-mr-4">
        <h1>{{selectedLanguage == 'US' ? en.title_contact : pt.title_contact}}</h1>
        <!-- <h1>Teste</h1> -->
      </div>
      <hr class="tw-border-dashed tw-border-sky-700 tw-mt-1">
      <section class="tw-py-8 tw-w-full" v-if="pageOptions && (pageOptions.email || pageOptions.contractor_email || pageOptions.contractor_phone)">
        <div class="tw-container tw-mx-auto tw-flex tw-flex-wrap">
          <div :class="{'tw-mb-10 md:tw-mb-0 md:tw-w-6/12': pageOptions.contractor_email || pageOptions.contractor_phone}" class="tw-w-full tw-items-center tw-mb-3 tw-text-center" v-if="pageOptions.email">
              <h3 class="tw-font-sans tw-text-white tw-text-xl md:tw-text-2xl tw-font-extrabold tw-m-0 tw-mb-5">{{selectedLanguage == 'US' ? en.title_contact_me : pt.title_contact_me}}</h3>
              <a :href="'mailto:'+pageOptions.email" class="tw-text-gray-900 tw-font-sans tw-uppercase tw-font-medium tw-text-xs tw-bg-white tw-rounded tw-px-6 tw-py-3"><i class="fas fa-envelope tw-mr-2"></i> {{selectedLanguage == 'US' ? en.bt_contact_me : pt.bt_contact_me}}</a>
          </div>
          <div :class="{'md:tw-w-6/12': pageOptions.email}" class="tw-w-full tw-flex tw-flex-wrap tw-text-center tw-justify-center" v-if="pageOptions.contractor_email || pageOptions.contractor_phone">
            <h3 class="tw-font-sans tw-text-white tw-text-xl md:tw-text-2xl tw-font-extrabold tw-m-0 tw-mb-3">{{selectedLanguage == 'US' ? en.contractors : pt.contractors}}</h3>
            <div class="tw-font-sans tw-w-full">
                <a :href="'mailto:'+pageOptions.contractor_email" class="tw-pb-3 tw-text-white"><i class="fas fa-envelope tw-mr-1"></i>{{pageOptions.contractor_email}}</a>
                <p class="tw-mb-0 tw-mt-2"><i class="fas fa-phone tw-mr-1"></i>{{pageOptions.contractor_phone}}</p>
            </div>
          </div>
        </div>
      </section>
      <section id="pressKit" class="tw-py-8 tw-w-full" v-if="pageOptions && (pageOptions.technical_kit_link || pageOptions.press_kit_link)">
        <div class="tw-container tw-mx-auto">
            <div class="tw-flex tw-flex-wrap tw-items-center tw-mb-3">
                <div class="tw-w-full tw-text-center tw-justify-center tw-mb-5 md:tw-mb-0" :class="{'md:tw-w-6/12': pageOptions.press_kit_link.length , 'md:tw-w-full': !pageOptions.press_kit_link.length }" v-if="pageOptions.technical_kit_link.length">
                    <h3 class="tw-text-white tw-font-sans tw-font-bold tw-m-0 tw-text-3xl">{{selectedLanguage == 'US' ? en.title_kit : pt.title_kit}}</h3>
                    <div class="tw=text=sm tw-opacity-40 tw-text-white tw-font-sans tw-mb-3">{{selectedLanguage == 'US' ? en.sub_title_kit : pt.sub_title_kit}}</div>
                    <v-dialog v-model="technical" max-width="450" transition="scroll-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn color="white"  v-on="on" class="tw-text-gray-900 tw-font-sans tw-uppercase tw-font-medium tw-text-xs tw-bg-white tw-rounded tw-px-6 tw-py-3" light>
                                Download
                            </v-btn>
                        </template>
                        <v-card>
                            <v-toolbar dark color="purple">
                                <v-btn icon dark small class="tw-ml-1" @click="technical = false">
                                    <v-icon class="tw-text-sm">fas fa-times</v-icon>
                                </v-btn>
                                <v-toolbar-title class="tw-font-sans tw-pl-2">{{selectedLanguage == 'US' ? en.title_kit : pt.title_kit}}</v-toolbar-title>
                            </v-toolbar>
                            <div class="tw-px-2 tw-py-4 tw-w-full" v-if="pageOptions.technical_kit_password ? !technical_free : false">
                                <h4 class="tw-text-white tw-font-sans tw-font-bold tw-text-xl tw-m-0">{{selectedLanguage == 'US' ? en.file_protected_title : pt.file_protected_title}}</h4>
                                <div class="tw=text=sm tw-opacity-40 tw-text-white tw-font-sans tw-mb-3 tw-text-sm">{{selectedLanguage == 'US' ? en.file_protected_title_input : pt.file_protected_title_input}}</div>
                                <div class="tw-py-3 tw-px-3 tw-m-0 tw-h-auto tw-rounded tw-bg-black tw-flex-1 tw-min-w-full tw-flex">
                                    <input type="password" v-model="technical_password" class="tw-font-sans tw-text-white tw-m-0 tw-h-auto tw-rounded tw-text-sm tw-bg-black tw-border-0 focus:tw-shadow-none tw-flex-1 tw-min-w-full tw-flex">
                                </div>
                                <v-btn block class="tw-mt-3 tw-text-xs tw-tracking-widest tw-font-sans" color="purple" dark @click="verifyPassword('technical')">{{selectedLanguage == 'US' ? en.file_protected_bt : pt.file_protected_bt}}</v-btn>
                            </div>
                            <div class="tw-px-2 tw-py-4 tw-w-full" v-if="pageOptions.technical_kit_password ? technical_free : true">
                                <div class="tw-w-full tw-flex tw-items-center tw-py-2 tw-px-3 tw-border tw-rounded tw-justify-between" id="shareLink">
                                    <div class="tw-mr-4 tw-text-sm tw-font-light tw-truncate tw-font-sans tw-opacity-40 tw-cursor-default tw-pointer-events-none">{{ pageOptions.technical_kit_link }}</div>
                                    <a :href="pageOptions.technical_kit_link" target="_blank" class="tw-h-full tw-px-6 tw-py-2 tw-inline-flex tw-items-center tw-justify-center tw-text-white tw-font-sans tw-uppercase tw-text-xs tw-whitespace-no-wrap tw-rounded" v-ripple>{{selectedLanguage == 'US' ? en.protected_bt_open : pt.protected_bt_open}}</a>
                                </div>
                            </div>
                        </v-card>
                    </v-dialog>
                </div>
                <div class="tw-w-full tw-text-center tw-justify-center" :class="{'md:tw-w-6/12': pageOptions.technical_kit_link.length, 'md:tw-w-full': !pageOptions.technical_kit_link.length }" v-if="pageOptions.press_kit_link.length">
                    <h3 class="tw-text-white tw-font-sans tw-font-bold tw-m-0 tw-text-3xl">{{selectedLanguage == 'US' ? en.title_kit_press : pt.title_kit_press}}</h3>
                    <div class="tw=text=sm tw-opacity-40 tw-text-white tw-font-sans tw-mb-3">{{selectedLanguage == 'US' ? en.sub_title_kit : pt.sub_title_kit}}</div>
                    <v-dialog v-model="press" max-width="450" transition="scroll-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn color="white"  v-on="on" class="tw-text-gray-900 tw-font-sans tw-uppercase tw-font-medium tw-text-xs tw-bg-white tw-rounded tw-px-6 tw-py-3" light>
                                Download
                            </v-btn>
                        </template>
                        <v-card>
                            <v-toolbar dark color="purple">
                                <v-btn icon dark small class="tw-ml-1" @click="press = false">
                                    <v-icon class="tw-text-sm">fas fa-times</v-icon>
                                </v-btn>
                                <v-toolbar-title class="tw-font-sans tw-pl-2">{{selectedLanguage == 'US' ? en.title_kit_press : pt.title_kit_press}}</v-toolbar-title>
                            </v-toolbar>
                            <div class="tw-px-2 tw-py-4 tw-w-full" v-if="pageOptions.press_kit_password ? !press_free : false">
                                <h4 class="tw-text-white tw-font-sans tw-font-bold tw-text-xl tw-m-0">{{selectedLanguage == 'US' ? en.file_protected_title : pt.file_protected_title}}</h4>
                                <div class="tw=text=sm tw-opacity-40 tw-text-white tw-font-sans tw-mb-3 tw-text-sm">{{selectedLanguage == 'US' ? en.file_protected_title_input : pt.file_protected_title_input}}</div>
                                <div class="tw-py-3 tw-px-3 tw-m-0 tw-h-auto tw-rounded tw-bg-black tw-flex-1 tw-min-w-full tw-flex">
                                    <input type="password" v-model="press_password" class="tw-font-sans tw-text-white tw-m-0 tw-h-auto tw-rounded tw-text-sm tw-bg-black tw-border-0 focus:tw-shadow-none tw-flex-1 tw-min-w-full tw-flex">
                                </div>
                                <v-btn block class="tw-mt-3 tw-text-xs tw-tracking-widest tw-font-sans" color="purple" dark @click="verifyPassword('press')">{{selectedLanguage == 'US' ? en.file_protected_bt : pt.file_protected_bt}}</v-btn>
                            </div>
                            <div class="tw-px-2 tw-py-4 tw-w-full" v-if="pageOptions.press_kit_password ? press_free : true">
                                <div class="tw-w-full tw-flex tw-items-center tw-py-2 tw-px-3 tw-border tw-rounded tw-justify-between" id="shareLink">
                                    <div class="tw-mr-4 tw-text-sm tw-font-light tw-truncate tw-font-sans tw-opacity-40 tw-cursor-default tw-pointer-events-none">{{ pageOptions.press_kit_link }}</div>
                                    <a :href="pageOptions.press_kit_link" target="_blank" class="tw-h-full tw-px-6 tw-py-2 tw-inline-flex tw-items-center tw-justify-center tw-text-white tw-font-sans tw-uppercase tw-text-xs tw-whitespace-no-wrap tw-rounded" v-ripple>{{selectedLanguage == 'US' ? en.protected_bt_open : pt.protected_bt_open}}</a>
                                </div>
                            </div>
                        </v-card>
                    </v-dialog>
                </div>
            </div>
        </div>
        <v-snackbar v-model="snackbar" :multi-line="false" right top>
            {{ snackbar_text }}
            <template v-slot:action="{ attrs }">
                <v-btn color="red" text v-bind="attrs" @click="snackbar = false">{{selectedLanguage == 'US' ? en.protected_bt_close : pt.protected_bt_close}}</v-btn>
            </template>
        </v-snackbar>
      </section>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout2';
import EventBus from '@/eventbus';
import pt from "../../../../../lang/smartsite/layout_2/layout_2.js";

export default {
mixins: [pt],
  layout: (h, page) => h(Layout, [page]),
  layout: Layout,
  props: ['artist', 'spotifyArtist', 'pageOptions'],
  data(){
    return{
      snackbar: false,
      snackbar_text: '',
      technical: false,
      technical_free: false,
      technical_password: '',
      press: false,
      press_free: false,
      press_password: '',
    }
  },
  computed: {
    selectedLanguage() {
      return this.$page.props.lang;
    }
  },
  methods: {
    verifyPassword(val){
      axios.post(`/api/presskit/password/${this.pageOptions.id}`, {
          type: val,
          password: val == 'press' ? this.press_password : this.technical_password
      })
      .then(res => {
          if(res.data.password){
              val == 'press' ? this.press_free = true : this.technical_free = true;
          } else {
              this.snackbar = true;
              this.snackbar_text = this.verifyPassword
          }
      });
    },
  },
  created(){
    EventBus.$emit('artist', {'artist': this.artist, 'pageOptions': this.pageOptions});
  }
}
</script>

<style>
    
</style>